import {
  Box,
  Flex,
  Avatar,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  useDisclosure,
  Stack,
  Center,
  Text,
  useMediaQuery,
} from '@chakra-ui/react'
import { Timer } from './Timer'
import { ImagemLogo } from './styles'
import logo from '../../images/logotipo.png'
import { useNavigate } from 'react-router-dom'
import ComponentCenterListMenu from './ComponentCenterListMenu'
import { useLocation } from '../../hooks/useLocation'
import { iconsForWeatherReactIcons } from '../../utils/iconsWeather'
import { traduceWeather } from '../../utils/traduceWeather'
import { useState, useEffect } from 'react'
import { HeaderMobile } from './HeaderMobile'
import { user } from '../../helpers/user'
import { WorkdayCalendar } from '../WorkdayCalendar'

export function Header({ menupai, menufilho, nomeUsuario, avatarUrl }) {
  const { location, weather } = useLocation()
  const { name, main, weather: weatherData } = weather
  const [isLargerThan768] = useMediaQuery('(min-width: 768px)')
  const [isMobile, setIsMobile] = useState(false)

  const codUsuPermission = {
    30: 30,
    0: 0,
    42: 42,
    43: 43,
  }

  useEffect(() => {
    if (isLargerThan768) {
      setIsMobile(false)
    } else {
      setIsMobile(true)
    }
  }, [isLargerThan768])

  const celcius = main && main.temp ? main.temp - 273.15 : 0

  const navigate = useNavigate()
  return (
    <>
      {!isMobile ? (
        <Box bg={'#313E44'} px={4}>
          <Flex h={16} alignItems={'center'} justifyContent={'space-between'} height="fit-content">
            <Box>
              <ImagemLogo src={logo} alt="Logo Innovation" onClick={() => navigate('/')} />
            </Box>

            <ComponentCenterListMenu menufilho={menufilho} menupai={menupai} />

            <Flex alignItems={'center'}>
              <Stack direction={'row'} spacing={7}>
                {codUsuPermission[user?.codigo_usuario] && (
                  <Button as="a" href="https://innovationbrindes.com.br/atendimento" target="_blank" colorScheme="blue" size="sm">
                    Atendimento
                  </Button>
                )}

                <Menu isLazy zIndex={4}>
                  <MenuButton as={Button} rounded={'full'} variant={'link'} cursor={'pointer'} minW={0} position={'relative'} zIndex={3}>
                    <Text as="span" fontSize="14px" color="gray.600" mr="2" position="absolute" top="-24px" right="20px" zIndex={0}>
                      <Flex gap={2} alignItems="flex-start" justifyContent="flex-start">
                        {/* {dateHoje.toLocaleDateString("pt-BR", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      })}{" "}
                      <HourInRealTime /> */}
                        <Timer />
                      </Flex>
                    </Text>
                    <Avatar size={'sm'} name={nomeUsuario} src={avatarUrl} />
                    <Box position="absolute" bottom="3px" right="0px" bg="green.500" w="10px" h="10px" borderRadius="50%" />
                  </MenuButton>

                  <MenuList alignItems={'center'} position="relative" zIndex={3}>
                    <br />
                    <Center>
                      <Avatar size={'2xl'} name={nomeUsuario} src={avatarUrl} />
                    </Center>
                    <br />
                    <Center>
                      <p>{nomeUsuario}</p>
                    </Center>
                    <br />
                    <Center>
                      {location.latitude && location.longitude && (
                        <>
                          <p>
                            {name} - {celcius.toFixed(2)}°C
                          </p>
                        </>
                      )}
                    </Center>
                    <br />
                    <Center>
                      <Flex gap={1}>
                        <p>{weatherData && weatherData[0] && traduceWeather(weatherData[0].description)}</p>
                        {iconsForWeatherReactIcons(weatherData && weatherData[0] && weatherData[0].main)}
                      </Flex>
                    </Center>
                    <MenuDivider />
                    <MenuItem
                      onClick={() => {
                        localStorage.removeItem('authentication')
                        window.location.href = '/login'
                      }}
                    >
                      Sair
                    </MenuItem>
                  </MenuList>
                </Menu>
              </Stack>
            </Flex>
          </Flex>
        </Box>
      ) : (
        <Box bgColor="#378BBF">
          <HeaderMobile menupai={menupai} menufilho={menufilho} />
        </Box>
      )}
    </>
  )
}
